import { Component } from '@angular/core';
import 'devextreme/data/odata/store';
import { EnvironmentService } from '../../services/environment.service';

@Component({
  templateUrl: './card-disbursement.component.html',
  styleUrl: './card-disbursement.component.scss'
})
export class CardDisbursementComponent {
  dataSource: any;

  constructor(private environmentService: EnvironmentService) {
    this.dataSource = {
      store: {
        version: 4,
        type: 'odata',
        key: 'Id',
        url: this.environmentService.getConfig('BackendApi') + 'odata/Batches'
      }
    };
  }
}
